// Angular modules.
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ZkNotificationService } from '@zenklub/ng-ui';
import { CalendarNavState } from 'app/interfaces/calendar.interface';
// Zenklub services.
import { ContactsService } from 'app/services/contacts.service';

@Component({
	selector: 'app-appointments',
	templateUrl: './appointments.component.html',
	styleUrls: ['./appointments.component.scss'],
})
export class AppointmentsComponent implements OnInit {
	// Current active screen.
	activeScreen: string;

	// Calendar data.
	calendarLabels: any;

	// Edit data.
	editMode = false;
	editId: string;
	operationType = 'online';
	addNew = false;
	contactId: number;
	userId: string;

	// mobile navigation related.
	returnTo: CalendarNavState;

	// Constructor method.
	constructor(
		protected contacts: ContactsService,
		protected notifications: ZkNotificationService,
		protected route: ActivatedRoute,
		protected router: Router
	) {}

	// On init.
	public ngOnInit(): void {
		// Verify if was given and user ID.
		const addWithId: boolean = window.location.pathname.indexOf('/add/') > -1;

		// Store previous page (force return to a specific page).
		this.returnTo = history.state;

		this.route.params.subscribe((params) => {
			const evId: string = params['id'];
			if (!addWithId && evId) {
				this.addNew = false;
				this.editMode = true;
				this.editId = evId;
				this.contactId = null;
				this.activeScreen = 'Session';
			} else if (addWithId && evId) {
				this.addNew = true;
				this.editMode = true;
				this.editId = null;
				this.contactId = Number(evId);
				this.activeScreen = 'Session';
			} else {
				this.addNew = false;
				this.editMode = false;
				this.editId = null;
				this.contactId = null;
				this.activeScreen = 'Options';
			}

			if (params['type'] && params['type'] === 'busyslot') {
				this.operationType = 'personal';
			}

			if (params['operationType']) {
				this.editMode = false;
				this.editId = null;
				this.addNew = true;
				this.activeScreen = 'Session';
				this.operationType = params['operationType'];
			}
		});
	}

	// Change active screen.
	public changeActiveScreen(screen: string): void {
		this.addNew = screen !== 'Options';
		this.operationType = screen;
		this.activeScreen = screen !== 'Options' ? 'Session' : 'Options';
	}
}
